/**
 * 纪委两责系统===================================
 */

// danwei领导
// export default {
//   g_person_id: '75177592289',
//   name: '979ab3d0a41e1d0aa977fd761e104659',
//   product_code: 'JW_system'
// }

// 派驻填报人
export default {
  g_person_id: '75177594308',
  name: '50b915ccd9df38d00a9a2dca1759604e',
  product_code: 'JW_system'
}

// 派驻审核员
// export default {
//   g_person_id: '75177616233',
//   name: '1d1e60fc4cee0a71c44663cdfd47da47',
//   product_code: 'JW_system'
// }

// 派驻审核人
// export default {
//   g_person_id: '75177616233',
//   name: '1d1e60fc4cee0a71c44663cdfd47da47',
//   product_code: 'JW_system'
// }

// 纪委审核员
// export default {
//   g_person_id: '71217887811',
//   name: '85ab00c86ab2f783657d8fb87b70a47f',
//   product_code: 'JW_system'
// }

// 党委填报员
// export default {
//   g_person_id: '69217887798',
//   name: '2a3c524a157d6548315631832fe707e2',
//   product_code: 'JW_system'
// }

// 派驻填报员
// export default {
//   g_person_id: '75177594308',
//   name: '50b915ccd9df38d00a9a2dca1759604e',
//   product_code: 'JW_system'
// }

// 党委填报人
// export default {
//   g_person_id: '8422440849',
//   name: 'c9a2528ba83f2477960ff92476c390c2',
//   product_code: 'JW_system'
// }

/**
 * 签到==================================================
 */
// 签到测试
// export default {
//     g_person_id: '69217887798',
//     name: '2a3c524a157d6548315631832fe707e2',
//     product_code: 'CheckIn'
// }



// WEBPACK FOOTER //
// ./src/dev-variable/dev-variable.js